import { environment } from "../environments/environment";

export const apiEndpoints = {
    paciens: `${environment.apiUrl}/v01/paciens`,
    auth: `${environment.apiUrl}/v01/auth`,
    komplexum: `${environment.apiUrl}/v01/komplexum`,
};
